import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface TimerDisplayProps {
  seconds: number;
  maxSeconds?: number;
  urgent?: boolean;
  className?: string;
}

export function TimerDisplay({ seconds, maxSeconds = 20, urgent = false, className }: TimerDisplayProps) {
  const isUrgent = seconds <= 5 || urgent;
  const progress = (seconds / maxSeconds) * 100;

  return (
    <div className={cn('flex flex-col items-center gap-2', className)}>
      {/* Timer number */}
      <motion.div
        className={cn(
          'font-mono font-bold text-4xl',
          isUrgent ? 'text-opponent timer-urgent' : 'text-foreground'
        )}
        key={seconds}
        initial={{ scale: 1.2, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.2 }}
      >
        {seconds}
      </motion.div>
      
      {/* Progress bar */}
      <div className="w-32 h-2 rounded-full bg-secondary overflow-hidden">
        <motion.div
          className={cn(
            'h-full rounded-full',
            isUrgent ? 'bg-opponent' : 'bg-primary'
          )}
          initial={{ width: '100%' }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.3 }}
        />
      </div>
      
      <span className="text-xs text-muted-foreground uppercase tracking-wider">
        seconds
      </span>
    </div>
  );
}
